import { ChevronDown, SquareCheckIcon, SquareIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type Option<T> = { label: string; value: T };

export function OfferSearchFilter<T>(
  props: {
    label: string;
    options: Option<T>[];
  } & (
    | {
        multiple: false;
        value: Option<T>;
        onChange: (value: Option<T>) => void;
      }
    | {
        multiple: true;
        value: Option<T>[];
        onChange: (value: Option<T>[]) => void;
      }
  )
) {
  const { label, multiple, options, value, onChange } = props;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline">
          <span>{label}</span>
          <ChevronDown className="ml-1" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {options.map((option) => {
          const isSelected = multiple
            ? value.some((val) => val.value === option.value)
            : value.value === option.value;
          return (
            <DropdownMenuItem
              key={`${option.label}_${option.value}`}
              aria-label={multiple ? 'menuitemcheckbox' : 'menuitemradio'}
              aria-checked={isSelected}
              tabIndex={0}
              onClick={() => {
                if (multiple) {
                  if (isSelected) {
                    onChange(value.filter((val) => val.value !== option.value));
                  } else {
                    onChange([...value, option]);
                  }
                } else {
                  onChange(option);
                }
              }}
            >
              {!multiple ? null : isSelected ? <SquareCheckIcon /> : <SquareIcon />}
              <span>{option.label}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
